import { StyleSheet } from "react-native"
import { appColors, appFonts, fontSize } from "../../appTheme"
import { AppTheme } from "../../theme"
export const timeCardListStyle = (theme: AppTheme) => StyleSheet.create({

    container: {
        flex: 1,
        backgroundColor: appColors?.lightBackgroundColor
    },
    textStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.smallFontSize
    },
    buttonTextStyle: {
        fontSize: theme?.errorFontSize, fontFamily: appFonts.bold,
    },
    totalHoursStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.smallFontSize,
        color: appColors?.lightDark
    },
    popoverStyle: {
        borderRadius: 10
    },
    labelStyle: {
        color: appColors.labelColor,
        fontSize: theme?.smallFontSize,
    },
    iconBackgroundStyle: {
        padding: 10,
        backgroundColor: appColors?.lightBackgroundColor,
        borderRadius: 10,
    },
    actionCircleButton: {
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: appColors.lightBackgroundColor,
        justifyContent: 'center',
        alignItems: 'center',
    },
    actionDeleteCircleButton: {
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: '#FEF2F2',
        justifyContent: 'center',
        alignItems: 'center',
    },
    plusIconView: {
        alignSelf: "flex-end",
        backgroundColor: appColors.primary,
        borderRadius: 50,
        alignItems: "center",
        justifyContent: "center",
        height: 55,
        width: 55,
        position: "absolute",
        bottom: 25,
        right: 25
    },
    deleteIconView: {
        alignSelf: "flex-end",
        backgroundColor: appColors.red,
        borderRadius: 50,
        alignItems: "center",
        justifyContent: "center",
        height: 55,
        width: 55,
        position: "absolute",
        bottom: 25,
        right: 25
    },
})